import React, { Component } from 'react';
import UsersListItem from './UsersListItem.js';

class UsersList extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			openedUserRow: false
		};

		this.foldUserRow = this.foldUserRow.bind(this);
	}

	foldUserRow (userId) {
		if (userId === this.state.openedUserRow && this.state.openedUserRow !== false) {
			userId = false;
		}

		this.setState({ openedUserRow: userId });
	}

	retrieveLanguageServerTokens (serverTokens) {
		let tokenInformation = {
			actions: [],
			tokens: []
		};

		serverTokens.forEach(function (token) {
			let tokenSplit = token.key.split('.');

			const action = tokenSplit[0];
			const entity = tokenSplit[1];
			let entitySplit = null;

			if (entity.indexOf("::") !== -1) {
				const entitySplit = entity.split('::');
				let entityKey = token.entity.key;

				if (! (entityKey in tokenInformation.tokens)) {
					tokenInformation.tokens[entityKey] = [];
				}

				tokenInformation.tokens[entityKey][action] = { key: token.key, action: action, entity: token.entity.key };

				if (tokenInformation.actions.indexOf(action) <= -1) {
					tokenInformation.actions.push({ name: action, description: token.description });
				}
			}
		});

		return tokenInformation;
	}

	render () {
		const that = this;

		return (
			<div className="user-rows-list">
				{(this.props.users.length &&
					this.props.users.map(function (user) {
						const isOpen = that.state.openedUserRow !== false && user.props.id === that.state.openedUserRow;

						return <UsersListItem
							serverTokens={that.retrieveLanguageServerTokens(that.props.serverTokens)}
							user={user}
							key={`user.${user.props.id}`}
							deleter={that.props.deleter}
							updater={that.props.updater}
							enabler={that.props.enabler}
							foldAction={that.foldUserRow}
							folded={!(isOpen)}
						/>
					})
				)}
			</div>
		);
	}
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersList.js